import React, { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase/firebaseConfig";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";


import { Signup } from "./pages/Signup/Signup"
import { Login } from "./pages/Login/Login";
import { ForgotPassword } from "./pages/ForgotPassword/ForgotPassword";
import { Dashboard } from "./pages/Dashboard/Dashboard"
import { Profile } from "./pages/Profile/Profile"
import { TimeManager } from "./pages/TimeManager/TimeManager";

import { UserProvider } from "./context/UserContext";
import { Scheduler } from "./pages/Scheduler/Scheduler";
import { Payroll } from "./pages/Payroll/Payroll";
import {Kiosk} from "./pages/Kiosk/Kiosk"
import { KioskAuthentication } from "./pages/KioskAuthentication/KioskAuthentication";
import { EmployeePto } from "./pages/EmployeePto/EmployeePto";
import { DateRangeProvider } from "./context/DateRangeContext"


//TODO: if ANY route is accessed and there is no user session then kick them back to the home page '/'
const App: React.FC = () => {
    const [user, setUser] = useState<any>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                setUser(user);
            } else {
                setUser(null);
            }
            setLoading(false); // Stop loading once the state is determined
        });

        return () => unsubscribe();
    }, []);

    if (loading) return <p>Loading...</p>; // Display loading while checking auth state
    return (
        <>
            <UserProvider>
                <DateRangeProvider>
                    <Router>
                        <Routes>
                            <Route path="/signup" element={<Signup />} />
                            <Route path="/kiosk" element={<Kiosk />} />
                            <Route path="/kiosk/authentication" element={<KioskAuthentication />} />
                            <Route path="/forgot-password" element={<ForgotPassword />} />

                            <Route
                                path="/"
                                element={user ? <Navigate to="/dashboard" /> : <Login />}
                            />
                            <Route
                                path="/dashboard"
                                element={user ? <Dashboard /> : <Navigate to="/" />}
                            />
                            <Route
                                path="/profile"
                                element={user ? <Profile /> : <Navigate to="/" />}
                            />

                            <Route
                                path="/scheduler"
                                element={user ? <Scheduler /> : <Navigate to="/" />}
                            />
                            <Route
                                path="/payroll"
                                element={user ? <Payroll /> : <Navigate to="/" />}
                            />
                            <Route
                                path="/time-manager"
                                element={user ? <TimeManager employeeDetailPage={false}/> : <Navigate to="/" />}
                            />
                            <Route path="/employees/:employeeId" element={<TimeManager employeeDetailPage={true}/>} />
                            <Route path="/employees/:employeeId/pto" element={<EmployeePto />} />
                        </Routes>
                    </Router>
                </DateRangeProvider>
            </UserProvider >
        </>
    );
};

export default App;
